import React from "react";
import { Box, Typography, Tooltip, alpha } from "@mui/material";
import { Schedule as TimeIcon } from "@mui/icons-material";

const formatTime = (seconds) => {
  if (!seconds || isNaN(seconds)) return "0m"; // Handle invalid/zero input

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  // Format based on values
  const parts = [];
  if (hours > 0) parts.push(`${hours}h`);
  if (minutes > 0 || parts.length === 0) parts.push(`${minutes}m`);

  return parts.join(" ");
};

const TimeDisplay = ({
  minutes,
  variant = "default",
  tooltip = "Total Time",
  showSeconds = true,
}) => {
  const variants = {
    default: {
      wrapper: {
        display: "flex",
        alignItems: "center",
        gap: 0.5,
      },
      text: {
        fontFamily: "monospace",
        fontWeight: "medium",
        minWidth: "80px",
        fontSize: "0.875rem",
      },
    },
    chip: {
      wrapper: {
        display: "flex",
        alignItems: "center",
        p: 0.5,
        px: 1,
        borderRadius: 1,
        bgcolor: (theme) => alpha(theme.palette.secondary.main, 0.07),
        "&:hover": {
          bgcolor: (theme) => alpha(theme.palette.secondary.main, 0.12),
        },
      },
      text: {
        ml: 0.5,
        fontFamily: "monospace",
        fontWeight: "medium",
        minWidth: "80px",
        fontSize: "0.875rem",
        letterSpacing: "0.02em",
      },
    },
    compact: {
      wrapper: {
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        p: 0.5,
        borderRadius: 1,
        bgcolor: (theme) => alpha(theme.palette.secondary.main, 0.07),
      },
      text: {
        fontFamily: "monospace",
        fontWeight: "medium",
        minWidth: "60px",
        fontSize: "0.75rem",
      },
    },
  };

  const formattedTime = formatTime(minutes);
  const tooltipText = `Total Time: ${formattedTime}`;

  return (
    <Tooltip title={tooltipText}>
      <Box sx={variants[variant].wrapper}>
        <TimeIcon
          fontSize="small"
          color="secondary"
          sx={{
            fontSize: variant === "compact" ? "1rem" : "1.25rem",
            opacity: 0.8,
          }}
        />
        <Typography
          variant="body2"
          color="text.secondary"
          sx={variants[variant].text}
        >
          {formattedTime}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default React.memo(TimeDisplay);
